export type AppVersion = {
  id: string;
  name: string;
  functionId: string;
  functionVersionId: string;
};

export type SolutionOmniverseApp = {
  id: string;
  solutionId: string;
  siteId: string;
  functionId: string;
  functionVersionId: string;
  title: string;
  description: string;
  version: string;
  image: string;
  icon: string;
  category: string;
  productArea: string;
  authenticationType: string;
  mediaServer: string;
  mediaPort: number;
  status: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  latestVersion?: AppVersion;
  versions?: AppVersion[];
};

export enum SolutionOmniverseAppField {
  Id = 'id',
  SolutionId = 'solutionId',
  SiteId = 'siteId',
  FunctionId = 'functionId',
  FunctionVersionId = 'functionVersionId',
  Title = 'title',
  Description = 'description',
  Version = 'version',
  Image = 'image',
  Icon = 'icon',
  Category = 'category',
  ProductArea = 'productArea',
  AuthenticationType = 'authenticationType',
  MediaServer = 'mediaServer',
  MediaPort = 'mediaPort',
  Status = 'status',
  CreatedBy = 'createdBy',
  CreatedAt = 'createdAt',
  UpdatedBy = 'updatedBy',
  UpdatedAt = 'updatedAt',
}
